import Icon from '../components/Icon.vue'

Icon.register({
  smog: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 368H80C71.2 368 64 375.2 64 384V400C64 408.8 71.2 416 80 416H624C632.8 416 640 408.8 640 400V384C640 375.2 632.8 368 624 368zM144 464H16C7.2 464 0 471.2 0 480V496C0 504.8 7.2 512 16 512H144C152.8 512 160 504.8 160 496V480C160 471.2 152.8 464 144 464zM560 464H224C215.2 464 208 471.2 208 480V496C208 504.8 215.2 512 224 512H560C568.8 512 576 504.8 576 496V480C576 471.2 568.8 464 560 464zM144 288H300.1C322.6 307.7 351.7 320 384 320S445.3 307.7 467.9 288H528C589.9 288 640 237.9 640 176S589.9 64 528 64C510 64 493.3 68.6 478.3 76.1 454 31 406.8 0 352 0 311 0 274.2 17.3 248 44.8 221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144S64.5 288 144 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/smog.js
// module id = QCJx
// module chunks = 144